import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const usePageTitle = () => {
  const location = useLocation();
  const { language } = useLanguage();

  useEffect(() => {
    const titles = {
      '/': language === 'fr' ? 'Accueil | Walaby' : 'Home | Walaby',
      '/expertise': language === 'fr' ? 'Nos Expertises | Walaby' : 'Our Expertise | Walaby',
      '/vision-sourcing': language === 'fr' ? 'Vision Sourcing | Walaby' : 'Sourcing Vision | Walaby',
      '/who-we-are': language === 'fr' ? 'Qui Sommes-Nous | Walaby' : 'Who We Are | Walaby',
      '/references': language === 'fr' ? 'Références | Walaby' : 'References | Walaby',
      '/contact': 'Contact | Walaby'
    };

    const title = titles[location.pathname] || 'Walaby Consulting';
    document.title = title;
  }, [location.pathname, language]);
};

export default usePageTitle;
